export enum SettingsSubKeys {
  BrowserAddress = 'BrowserAddress',
  TabCaching = 'TabCaching',
  MouseAnimationToggleState = 'on',
  MouseAnimationSpeed = 'duration',
  MouseAnimationSize = 'size',
  MouseAnimationColor = 'bgColor',
  ShowSpeakerPanelByDefault = 'ShowSpeakerPanelByDefault',
  DemoUrlDisplay = 'DemoUrlDisplay',
  PersistentStorageToggleState = 'PersistentStorageState',
}
